import { Box, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import * as S from '../../../../../Table.styled';

import { PaymentStatus } from 'api/models/payload/ClientsPayload';
import {
    CLIENT_PAYMENT_STATUSES,
    CLIENT_PAYMENT_STATUS_ICON_FILL,
    CLIENT_PAYMENT_STATUS_LABEL_KEYS,
    normalizeClientPaymentStatus,
} from 'helpers/clientPaymentStatus';
import useTranslate from 'hooks/useTranslate';
import { ReactComponent as DollarSymbol } from 'assets/icons/B2B/currency_exchange.svg';

interface PaymentStatusMenuButtonProps {
    status: PaymentStatus | string | null;
    dollarStyle?: React.CSSProperties;
    onSelect: (status: PaymentStatus) => void;
}

export const PaymentStatusMenuButton: React.FC<PaymentStatusMenuButtonProps> = ({
    status,
    dollarStyle,
    onSelect,
}) => {
    const { translate } = useTranslate();
    const current = normalizeClientPaymentStatus(status);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <S.CurrencyButton
                type="button"
                $paymentStatus={current}
                aria-label={translate('setPaymentStatus')}
                title={translate(CLIENT_PAYMENT_STATUS_LABEL_KEYS[current])}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setAnchorEl(event.currentTarget);
                }}
            >
                <DollarSymbol style={dollarStyle} />
            </S.CurrencyButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                onClick={(event) => event.stopPropagation()}
            >
                {CLIENT_PAYMENT_STATUSES.map((option) => (
                    <MenuItem
                        key={option}
                        selected={option === current}
                        onClick={() => {
                            setAnchorEl(null);
                            if (option !== current) {
                                onSelect(option);
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor: CLIENT_PAYMENT_STATUS_ICON_FILL[option],
                                mr: 1.5,
                            }}
                        />
                        {translate(CLIENT_PAYMENT_STATUS_LABEL_KEYS[option])}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
